import { type RootState } from '../rmsStore';

export default function getRuleEngineReducer(state: RootState) {
  return state.ruleEngineReducer;
}
